import script from "./BreadcrumbNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./BreadcrumbNav.vue?vue&type=script&setup=true&lang=ts"

import "./BreadcrumbNav.vue?vue&type=style&index=0&id=77c05c8b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77c05c8b"]])

export default __exports__